import { render, staticRenderFns } from "./ShareFormDialog.vue?vue&type=template&id=650341be"
import script from "./ShareFormDialog.vue?vue&type=script&lang=js"
export * from "./ShareFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports